export const Logo = ({ className = "h-11 w-11" }) => (
    <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
        <circle cx="50" cy="50" r="46" stroke="#D4AF37" strokeWidth="1.5" />
        <circle cx="50" cy="50" r="41" stroke="#D4AF37" strokeWidth="0.75" strokeDasharray="2 2" />
        <polygon points="50,12 54,42 50,38 46,42" fill="#D4AF37" />
        <path d="M35,32 L50,68 L65,32" stroke="#D4AF37" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const LogoLockup = ({ light = true }) => (
    <span className="flex items-center gap-3" data-testid="brand-logo">
        <Logo className="h-11 w-11 shrink-0" />
        <span className="leading-none">
            <span className={`block font-serif text-xl font-semibold tracking-wide ${light ? "text-ivory" : "text-navy"}`}>
                Vistaaryatra
            </span>
            <span className="mt-1 block text-[10px] font-medium uppercase tracking-[0.3em] text-brass">
                Tours &amp; Travels
            </span>
        </span>
    </span>
);
